import Swal from "sweetalert2";

export const BasicAlert = (title) => {
  return Swal.fire({ text: title , showConfirmButton: false, timer: 2000})
};

export const SuccessAlert = (title) => {
  return Swal.fire({ text: title , showConfirmButton: false, timer: 3000});
};
